module.exports = __webpack_public_path__ + "img/5.3004ba4b.jpg";